import { render, staticRenderFns } from "./policy.vue?vue&type=template&id=2c366b36&scoped=true&"
import script from "./policy.vue?vue&type=script&lang=js&"
export * from "./policy.vue?vue&type=script&lang=js&"
import style0 from "./policy.vue?vue&type=style&index=0&id=2c366b36&prod&lang=css&"
import style1 from "./policy.vue?vue&type=style&index=1&id=2c366b36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c366b36",
  null
  
)

export default component.exports